export default __webpack_public_path__ + "753724934fb08f70f01f1af3ba9cc7ae.svg";